<template>
  <div>
    <p class="mb-0">
      <strong v-if="rowNumber">Row: {{ rowNumber }}.</strong> {{ message }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'SocietyCSVUploadRowError',
  props: {
    rowNumber: String,
    message: String,
  },
};
</script>

<style scoped></style>
